import { z } from 'zod'

export const MentionedType = z.enum(['GROUP', 'PERSON', 'ACCESS_PROFILE'])

export type MentionedType = z.infer<typeof MentionedType>
